import React, { useState } from "react";
import { graphql } from "gatsby";
import { Box, Typography } from "@material-ui/core";
import deepEqual from "react-fast-compare";
import { CustomWrapper, CustomVideo } from "./style";
import { StoryVideoButtonFragment as Props } from "./__generated__/StoryVideoButtonFragment";
import StoryModal from "../../components/story-modal";
import VideoPlayButton from "../card/components/VideoPlayButton";
import { playButtonAnimations, wrapperAnimations } from "./animations";
import { convertDatoCmsAssetUrlToCloudfrontUrl } from "../../helpers/cdn";
import { analyticsTrackEvent } from "../../services/analytics";

function StoryVideoButton({
  ctaText,
  videoPreview,
  story,
  analyticsEvent
}: Props) {
  const [isStoryOpen, setStoryOpen] = useState(false);

  const handleClick = () => {
    setStoryOpen(true);
    if (analyticsEvent) {
      analyticsTrackEvent(analyticsEvent);
    }
  };

  return (
    <>
      {/* Video Button */}
      <CustomWrapper
        onClick={handleClick}
        variants={wrapperAnimations}
        initial="initial"
        whileHover="hover"
      >
        <Box
          width="100%"
          height="116px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          position="relative"
        >
          <CustomVideo
            controls={false}
            preload="auto"
            muted
            playsInline
            autoPlay
            disableRemotePlayback={true}
            loop
            poster={`${videoPreview.video.thumbnailUrl}?time=0`}
          >
            <source
              src={convertDatoCmsAssetUrlToCloudfrontUrl(videoPreview.url)}
              type={videoPreview.mimeType}
            />
          </CustomVideo>

          <VideoPlayButton
            color="white"
            size="52px"
            variants={playButtonAnimations}
          />
        </Box>

        <Box
          flex={1}
          textAlign="center"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="body2" className="compact">
            {ctaText}
          </Typography>
        </Box>
      </CustomWrapper>

      {/* Story */}
      <StoryModal
        open={isStoryOpen}
        onClose={() => setStoryOpen(false)}
        story={story}
      />
    </>
  );
}

export default React.memo(StoryVideoButton, deepEqual);

export const SpacerFragment = graphql`
  fragment StoryVideoButtonFragment on DatoCmsCModuleStoryVideoButton {
    ctaText
    story {
      ...StoryFragment
    }
    videoPreview {
      url
      mimeType
      video {
        thumbnailUrl(format: png)
      }
    }
    analyticsEvent
    container
    containerDisableGutters
    containerBackgroundColor
    model {
      apiKey
    }
  }
`;
